var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwilio1 = function SvgTwilio1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2253_200036)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF043D",
    stroke: "#fff",
    strokeWidth: 1.427,
    d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 25.155a5.155 5.155 0 1 1 0-10.31 5.155 5.155 0 0 1 0 10.31M20 13a7 7 0 1 0 0 14 7 7 0 0 0 0-14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.288 18.257a1.456 1.456 0 1 1 2.91 0 1.456 1.456 0 0 1-2.91 0m0 3.487a1.456 1.456 0 1 1 2.91 0 1.456 1.456 0 0 1-2.91 0m-3.487 0a1.456 1.456 0 1 1 2.911 0 1.456 1.456 0 0 1-2.91 0m0-3.487a1.456 1.456 0 1 1 2.911 0 1.456 1.456 0 0 1-2.91 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2253_200036",
    width: 38.83,
    height: 42.685,
    x: 0.219,
    y: 0.113,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2253_200036"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2253_200036",
    result: "shape"
  })))));
};
export default SvgTwilio1;